<template>
	<CountUp :start-val="startValue" :end-val="endValue" :options="options" />
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import CountUp from 'vue-countup-v3'
import { useUserStore } from '@/js/stores/user';

const userStore = useUserStore()

// Props
const props = defineProps({
	textTokenWrapper: {
		type: String,
		required: false,
		default: "%1",
	}
})

// Reactives
const options = ref({
	useGrouping: false,
	duration: 1,
	useEasing: true,
	prefix: '',
	suffix: '',
})
const startValue = ref(0)
const endValue = ref(0)

// Computeds
const points = computed(() => userStore.userPoints > 0 ? userStore.userPoints : 0)

// Watch
watch(points, newValue => { // We need to update startValue otherwise <CountUp> start counting from 0
	startValue.value = endValue.value
	endValue.value = newValue
})

onMounted(() => {
	startValue.value = 0
	endValue.value = points.value
	
	// We need to break text wrapper, and put beginning and the end as prefix and suffix
	const wrapperParts = props.textTokenWrapper.split("%1")
	
	options.value.prefix = wrapperParts[0]
	options.value.suffix = wrapperParts[1]
})
</script>
<style>
	.countup-wrap{
		display: inline-block;
	}
</style>